export default __webpack_public_path__ + "static/media/Marathi_dm_1.26780b11.mp3";